import container from 'modules/section-content';
import page from 'page';
import domify from 'domify';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm, PricingPlans } from 'components';
import PricingScripts from 'components/pricingPlans/vendor/index';
import abTesting from 'modules/ab-testing';
import React from 'react';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import splash from './b2c-page.pug';
import metadata from './metadata.json';

const pricingScripts = new PricingScripts();
const metricsLib = window.metricsLib;

export default function register() {
  page(
    '/b2c-customer-identity-management',
    render,
    renderPricingPlans,
    pricingScripts.loadScripts,
    pricingScripts.renderPricing,
    pricingScripts.renderFeatures,
    pricingScripts.snippets,
    snippets
  );
  page.exit('/b2c-customer-identity-management', unMountApp);
}

function renderPricingPlans(ctx, next) {
  abTesting.executeExperiment('show-pricing-plans', variant => {
    if (variant && variant.name === 'show-pricing-plans') {
      clientRender(
        <PricingPlans btnFooterText="SEE MORE PRICING INFO" />,
        document.querySelector('.solution-page-pricing-plans')
      );
    }
  });

  return next();
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm source="b2c" subject="New lead from B2C page" />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  contactFormModals();
  return next();
}

function contactFormModals() {
  // Contact Sales Form
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2c-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2c-contact-form', metricsData);
    },
    source: 'b2c-page'
  };

  /* eslint-env browser */
  document.querySelectorAll('.open-contact-form-modal').forEach(element => {
    element.addEventListener(
      'click',
      () => {
        const salesContactForm = new ContactForm(salesContactFormOptions);
        salesContactForm.show({ includePhoneField: true });
      },
      false
    );
  });
}

function unMountApp(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  unmountComponentAtNode(document.querySelector('.solution-page-pricing-plans'));
  return next();
}



// WEBPACK FOOTER //
// ./src/pages/b2c/b2c.js